exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".gvl-footer{font-size:14px;line-height:16px;z-index:99}.gvl-footer a{text-decoration:none}.gvl-footer .logo--germany{height:75px}", ""]);

